import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';

export function facebookFindLocation(
  storeName: string,
  storeId: string | number,
  cityName: string,
  intentSource = '',
): void {
  commonFacebookEventsUtil('FindLocation', {
    content_name: '',
    content_category: '',
    store_id: storeId,
    store_name: storeName,
    city: cityName,
    intent_source: intentSource,
  });
}
